class HorizontalNavBar {
  constructor(config) {
    this.travelling = false;
    this.direction = "";
    this.distance = config.distance || 150;
    this.containerElement = config.container || {};
    this.contentElement = config.content || {};
    this.leftArrow = config.leftArrow || {};
    this.rightArrow = config.rightArrow || {};

    this.setOverflowing();
    this.addListenerToContainer();
    this.addListenerToLeftArrow();
    this.addListenerToRightArrow();
    this.addListenerContent();

    let ticking = false;
    window.addEventListener("resize", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.setOverflowing();
          ticking = false;
        });
      }
      ticking = true;
    });
  }

  addListenerToContainer() {
    let ticking = false;
    this.containerElement.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.setOverflowing();
          ticking = false;
        });
      }
      ticking = true;
    });
  }

  addListenerToLeftArrow() {
    this.leftArrow.addEventListener("click", () => {
      if (this.travelling === true) {
        return;
      }

      const determineOverflow = this.determineOverflow(
        this.contentElement,
        this.containerElement
      );

      if (determineOverflow === "left" || determineOverflow === "both") {
        const availableScrollLeft = this.containerElement.scrollLeft;
        if (availableScrollLeft < this.distance * 2) {
          this.contentElement.style.transform =
            "translateX(" + availableScrollLeft + "px)";
        } else {
          this.contentElement.style.transform =
            "translateX(" + this.distance + "px)";
        }

        this.contentElement.classList.remove("no-transition");

        this.direction = "left";
        this.travelling = true;
      }

      this.setOverflowing();
    });
  }

  addListenerToRightArrow() {
    this.rightArrow.addEventListener("click", () => {
      if (this.travelling === true) {
        return;
      }

      const determineOverflow = this.determineOverflow(
        this.contentElement,
        this.containerElement
      );
      if (determineOverflow === "right" || determineOverflow === "both") {
        const contentRightEdge =
          this.contentElement.getBoundingClientRect().right;
        const containerRightEdge =
          this.containerElement.getBoundingClientRect().right;

        const availableScrollRight = Math.floor(
          contentRightEdge - containerRightEdge
        );
        if (availableScrollRight < this.distance * 2) {
          this.contentElement.style.transform =
            "translateX(-" + availableScrollRight + "px)";
        } else {
          this.contentElement.style.transform =
            "translateX(-" + this.distance + "px)";
        }

        this.contentElement.classList.remove("no-transition");
        this.direction = "right";
        this.travelling = true;
      }

      this.setOverflowing();
    });
  }

  addListenerContent() {
    this.contentElement.addEventListener(
      "transitionend",
      () => {
        const styleOfTransform = window.getComputedStyle(
          this.contentElement,
          null
        );
        const transform = styleOfTransform.getPropertyValue("transform");
        const amount = Math.abs(parseInt(transform.split(",")[4]) || 0);
        this.contentElement.style.transform = "none";
        this.contentElement.classList.add("no-transition");
        if (this.direction === "left") {
          this.containerElement.scrollLeft =
            this.containerElement.scrollLeft - amount;
        } else {
          this.containerElement.scrollLeft =
            this.containerElement.scrollLeft + amount;
        }
        this.travelling = false;
      },
      false
    );
  }

  setOverflowing() {
    this.containerElement.setAttribute(
      "data-overflowing",
      this.determineOverflow(this.contentElement, this.containerElement)
    );
  }

  determineOverflow(content, container) {
    let result = "none";

    const containerMetrics = container.getBoundingClientRect();
    const containerMetricsRight = Math.floor(containerMetrics.right);
    const containerMetricsLeft = Math.floor(containerMetrics.left);

    const contentMetrics = content.getBoundingClientRect();
    const contentMetricsRight = Math.floor(contentMetrics.right);
    const contentMetricsLeft = Math.floor(contentMetrics.left);

    switch (true) {
      case containerMetricsLeft > contentMetricsLeft &&
        containerMetricsRight < contentMetricsRight:
        result = "both";
        break;
      case contentMetricsLeft < containerMetricsLeft:
        result = "left";
        break;
      case contentMetricsRight > containerMetricsRight:
        result = "right";
        break;
    }
    return result;
  }
}

export default HorizontalNavBar;
